import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "../messages";

function* startContractsReport(action) {
  const params = {
    sort: "name",
    ...action.payload,
  };

  const { success, data, error } = yield* makeRequest.get("/enterprise/projects?csv=true", params);
  if (success && data) {
    yield put(actions.setContractsReport(data.body));
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_STARTING_CONTRACTS_REPORT,
    });
  }
  return null;
}

export default startContractsReport;
